import { SET_TYPE } from '../actionTypes';
import { configurationDocumentsActions } from '../reducer';

export default () => configurationDocumentsActions[SET_TYPE]();
